import { StoredImageDTO } from 'src/common/models/image';
import { CourseType } from 'src/common/models/courseType';
import { SpeakerDTO } from 'src/common/models/speaker';
import { EventDTO } from 'src/common/models/event';
import { ElearningUserEnrollment } from 'src/common/models/elearning';
import { parseISODateIfExist } from 'src/lib/date';
import { getElearningRoute } from 'src/elearning/routes';
import { getCourseEventSlugRoute, getCourseSlugRoute } from 'src/course/routes';
import { pipe } from 'fp-ts/function';
import { fromNullable, map as mapO, toUndefined } from 'fp-ts/Option';
import { CourseExcerpt } from 'src/common/models/courseExcerpt';

export interface RelatedCourseDTO {
  id: number;
  title: string;
  slug: string;
  comment: string;
  image: StoredImageDTO;
  type: CourseType;
  speaker: SpeakerDTO;
  event?: EventDTO;
  duration?: number;
  elearningUserEnrollment?: ElearningUserEnrollment;
}

const getRelatedCourseLink = (course: RelatedCourseDTO) => {
  if (course.type === CourseType.StandardCourse) {
    return course.event
      ? getCourseEventSlugRoute({ id: course.event.id }, course)
      : getCourseSlugRoute(course);
  } else {
    return getElearningRoute(course.elearningUserEnrollment ?? null, course);
  }
};

export const mapRelatedToCourseExcerpt = (relatedCourse: RelatedCourseDTO): CourseExcerpt => ({
  id: relatedCourse.type === CourseType.StandardCourse ? relatedCourse.event?.id : relatedCourse.id,
  comment: relatedCourse.comment,
  courseId: relatedCourse.id,
  courseType: relatedCourse.type,
  date: parseISODateIfExist(relatedCourse.event?.startDateTime),
  duration: relatedCourse.duration,
  elearningUserEnrollment: relatedCourse.elearningUserEnrollment ?? null,
  image: relatedCourse.image,
  link: getRelatedCourseLink(relatedCourse),
  slug: relatedCourse.slug,
  speaker: pipe(
    fromNullable(relatedCourse.speaker),
    mapO((a) => ({
      id: a.id,
      firstName: a.firstName,
      lastName: a.lastName,
      companyName: a.company,
    })),
    toUndefined,
  ),
  title: relatedCourse.title,
});
